import { FormattedMessage, useIntl } from "react-intl";
import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import Logo from "../../logo.svg";

const useStyles = makeStyles((theme) => ({
  generalBox: {
    padding: 25,
  },
  logo: {
    width: 150,
    Height: "auto",
  },
  logoContainer: {
    marginTop: 25,
    textAlign: "center",
    justifyContent: "center",
  },
  mainTitle: {
    fontSize: 40,
    marginLeft: 20,
    marginBottom: 5,
    padding: 5,
    textAlign: "center",
  },
  info: {
    fontSize: 20,
    marginLeft: 20,
    marginBottom: 5,
    padding: 5,
    textAlign: "center",
  },
  justInfo : {
    fontSize: 20,
  }
}));

interface DeleteAccountInfoProps {}

export const DeleteAccountInfo = (props: DeleteAccountInfoProps) => {
  const classes = useStyles(props);
  const { formatMessage } = useIntl();

  const render = () => {
    return (
      <Grid container item xs={12} sm={12} lg={12}>
        <Grid className={classes.logoContainer} item xs={12} sm={12} lg={12}>
          <img className={classes.logo} src={Logo} alt="ICIP Logo" />
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <Typography className={classes.mainTitle} variant="h2" component="h2">
            <FormattedMessage id="sharedScreen.howToDeleteMyAccount" /> ?
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <Typography className={classes.info} variant="h5" component="h5">
            <FormattedMessage id="sharedScreen.deleteAccountProcessStep1" />{" "}
            <br />
            <FormattedMessage id="sharedScreen.deleteAccountProcessStep2" />
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <Typography className={classes.mainTitle} variant="h2" component="h2">
            <FormattedMessage id="sharedScreen.whatDataIsDeleteWhenIDeleteMyAccount" />{" "}
            ?
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          lg={12}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <h5 className={classes.justInfo}>
            <FormattedMessage id="sharedScreen.allDataLinkedToYourAccountWillBeDeleted" />
          </h5>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          lg={12}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <ul>
            <li>
              <h5 className={classes.justInfo}>
                <FormattedMessage id="sharedScreen.yourPersonalInformations" />
              </h5>
            </li>
            <li>
              <h5 className={classes.justInfo}>
                <FormattedMessage id="sharedScreen.yourWallets" />
              </h5>
            </li>
            <li>
              <h5 className={classes.justInfo}>
                <FormattedMessage id="sharedScreen.yourTransactionHistory" />
              </h5>
            </li>
          </ul>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Box className={classes.generalBox} component="div">
        {render()}
      </Box>
    </>
  );
};

DeleteAccountInfo.routeName = "/public/account/deletion-info";
